import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';
import { MdRefresh } from 'react-icons/md';

const isLocalDev = () =>
  typeof window !== `undefined` &&
  (window.location.host === `vsly.local:8000` ||
    window.location.host === `vsly.localhost:8000`);

interface LocalReloadButtonProps {
  onClick: () => void;
  className?: string;
}

/**
 * A button that reloads the iframe, visible only in local development.
 * @param onClick - Function to call when the button is clicked
 * @param className - Optional CSS class name
 */
export function LocalReloadButton({
  onClick,
  className,
}: LocalReloadButtonProps) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(isLocalDev());
  }, []);
  if (!show) {
    return null;
  }

  const tooltipId = `local-reload-tooltip`;

  return (
    <>
      <StyledButton
        className={className}
        onClick={onClick}
        data-tip="This button is visible only in local development"
        data-for={tooltipId}
      >
        <MdRefresh size={18} />
      </StyledButton>
      <ReactTooltip id={tooltipId} place="top" effect="solid" />
    </>
  );
}

const StyledButton = styled.button`
  background: #f0f0f0;
  color: #555;
  border: 1px solid #ccc;
  padding: 0.4rem;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: fit-content;
  transition: all 0.2s ease-in-out;

  &:hover {
    background: #e0e0e0;
    color: #333;
    border-color: #bbb;
  }
`;
